export default __webpack_public_path__ + "static/zancudo_bunker-b80cb195d6fd7df79daff77f27d3a5e6.png";